import React, { useState } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@mui/styles";
import { TextField, InputAdornment } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import InputMask from "react-input-mask";
import { CustomButton } from "./customButton";
import { getVariant } from "../helpers/utils";

const useStyles = makeStyles(() => ({
  root: {
    padding: 16,
    display: "flex",
    flexDirection: "column",
    gap: 16,
    "& .MuiFormControl-root": {
      width: "100%",
    },
    "& .MuiInputBase-root": {
      height: 44,
    },
    "& .MuiFormHelperText-root": {
      color: 'var(--CUI2-error-error, #BE0F09) !important',
      margin: "6px 0",
      marginBottom:0,
      fontSize:14,
      fontWeight: 500,
      lineHeight: "20px", 
    },
    "& .MuiInputBase-input": {
      padding: "16px 12px",
    },
  },
  textFields: {
    display: "flex",
    gap: 16,
    flexDirection: "column",
  },
  actions: {
    display: "flex",
    gap: 8,
    flexDirection: "column",
  },
  textBlock: {
    marginBottom: 6,
    fontSize: 14,
    fontWeight: 600,
  },
  actionButton: {
    marginBottom: "8px !important",
  },
  actions: {
    display: "flex",
    flexDirection: "column",
    gap: 8,
  },
}));

export function FormInputcard({ content, handleClick, isRequired }) {
  const classes = useStyles();
  const [formValues, setformValues] = useState({});
  const [disabled, setIsdisabled] = useState(isRequired);
  const [disableTextField, setDisableTextField] = useState(false);
  const [errors, setErrors] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);

  const isPhoneNumberInvalid = (value) => {
    const digits = value.replace(/\D/g, "");
    return digits.length > 0 && digits.length < 10;
  };

  const confirmDropdown = (element) => {
    setIsSubmitted(true);
    element.data = { ...element.data, ...formValues };
    if (!errors.PhoneNumber) {
      setIsdisabled(true);
      setDisableTextField(true);
      handleClick(element);
    }
  };

  const handleTextFieldChange = (element, event) => {
    const value = event.target.value;
    setformValues((prevForm) => ({
      ...prevForm,
      [element.id]: value,
    }));

    if (element.id === "PhoneNumber") {
      setIsSubmitted(false);
      setErrors((prevErrors) => ({
        ...prevErrors,
        PhoneNumber: isPhoneNumberInvalid(value),
      }));
    }

    if (value.length) {
      setIsdisabled(false);
    } else {
      setIsdisabled(isRequired);
    }
  };

 return (
  <div className={classes.root}>
    <div className={classes.textFields}>
      {content.body.map((element) => {
        return (
          <div key={element.id}>
            <div className={classes.textBlock}>{element.label}</div>
            {element.id === "PhoneNumber" ? (
              // Separate InputMask for PhoneNumber
              <InputMask
                mask="999-999-9999"
                value={formValues[element.id] || ""}
                onChange={(event) => handleTextFieldChange(element, event)}
                disabled={disableTextField}
                maskChar="_"
              >
                {(inputProps) => (
                  <TextField
                    {...inputProps}
                    id={element.id}
                    variant="outlined"
                    error={errors.PhoneNumber}
                    placeholder="___-___-____"
                    helperText={
                      isSubmitted && errors.PhoneNumber
                        ? "Please enter a valid 10-digit phone number."
                        : ""
                    }
                    InputProps={{
                      endAdornment:
                        isSubmitted && errors.PhoneNumber ? (
                          <InputAdornment position="end">
                            <InfoOutlinedIcon color="error" />
                          </InputAdornment>
                        ) : null,
                    }}
                  />
                )}
              </InputMask>
            ) : (
              <TextField
                id={element.id}
                variant="outlined"
                value={formValues[element.id] || ""}
                onChange={(event) => handleTextFieldChange(element, event)}
                disabled={disableTextField}
              />
            )}
          </div>
        );
      })}
    </div>

    <div className={classes.actions}>
      {content?.actions.map((element) => (
        <CustomButton
          key={element.title}
          onClick={() => confirmDropdown(element)}
          variant={getVariant(element.title)}
          element={element}
          className={classes.actionButton}
          disabled={disabled}
        />
      ))}
    </div>
  </div>
);
}

FormInputcard.propTypes = {
  content: PropTypes.object,
  handleClick: PropTypes.func,
  isRequired: PropTypes.bool,
};
